import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { pathToRegexp } from "path-to-regexp"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectRedirect, updateRedirect } from "redux/features/auth/authSlice"
import { REDIRECT_LIST } from "config"

const RedirectComponent = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const redirect = useAppSelector((state) => selectRedirect(state))

  useEffect(() => {
    dispatch(updateRedirect({ redirect: null }))

    if (redirect && location.pathname === "/") {
      const isMatchingPath = REDIRECT_LIST.some((path) => {
        const regex = pathToRegexp(path)
        return regex.test(redirect)
      })

      if (isMatchingPath) {
        navigate(redirect)
      }
    }
  }, [location])

  return null
}

export default RedirectComponent
